import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Textarea from 'react-textarea-autosize';
import classnames from 'classnames';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

import { APIupdateFileExtraFields } from '../../../api/Files';

import ProcessingSpinner from '../../ProcessingSpinner';

import { sendTrackingEvent } from '../../../helpers';
import { userCan } from '../../../helpers/Auth';
import { addFlashMessage } from '../../../helpers/FlashMessages';

const FileTranscription = ({ file, readOnly }) => {
  const [text, setText] = useState(file.extra_fields?.transcription || '');
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);

  const intl = useIntl();

  useEffect(() => {
    sendTrackingEvent('file-transcription-sidebar-opened');
  }, []);

  useEffect(() => {
    setText(file.extra_fields?.transcription || '');
  }, [file.extra_fields]);

  if (!file || !file.attributes.transcription) {
    return null;
  }

  const handleUpdate = () => {
    setSaving(true);
    APIupdateFileExtraFields(file.uuid, { transcription: text }).then(() => {
      sendTrackingEvent('file-transcription-updated');
      addFlashMessage({
        type: 'success',
        text: intl.formatMessage({ defaultMessage: 'Transcription updated' }),
      });
      setSaving(false);
    });
  };

  return (
    <div className={classnames('file-transcription file-details-item file-sidebar-content-scrollable', { 'file-transcription-editing': editing })}>
      <div className="file-detail-header file-detail-header-light">
        <span>
          {intl.formatMessage({ defaultMessage: 'Transcription' })}
        </span>
      </div>
      <div className="file-detail-body file-detail-body-light">
        <Textarea
          className="form-control"
          name="transcription"
          value={text}
          readOnly={readOnly || !userCan('file.edit', file)}
          maxRows={99}
          onChange={e => setText(e.target.value)}
          onFocus={() => setEditing(true)}
          onBlur={() => setEditing(false)}
        />
        {userCan('file.edit', file) && !readOnly && (
          <Button color="primary" disabled={saving} onClick={handleUpdate}>
            {saving && (
              <ProcessingSpinner />
            )}
            {saving ? intl.formatMessage({ defaultMessage: 'Saving...' }) : intl.formatMessage({ defaultMessage: 'Update' })}
          </Button>
        )}
      </div>
    </div>
  );
};

FileTranscription.propTypes = {
  file: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
};

FileTranscription.defaultProps = {
  readOnly: false,
};

export default FileTranscription;
